import useToastStore from "@lib/stores/toast";
import { useMemo } from "react";

const useToast = () => {
  const addToast = useToastStore((state) => state.addToast);

  const toast = useMemo(() => {
    const toastFn = (options) => {
      // Support both string or object as first argument
      const config = typeof options === "string" ? { text: options } : options;

      const {
        type = "info",
        text = "",
        message = "", // Support message alias
        duration = 3000,
        position = "bottom-right",
        animation = "animate-slide-in-up",
        animationDuration = 300,
      } = config;

      addToast({
        type,
        text: text || message, // Fallback to message if text is empty
        duration,
        position,
        animation,
        animationDuration,
      });
    };

    // Provide convenience methods
    toastFn.success = (text, options) => toastFn({ type: "success", text, ...options });
    toastFn.error = (text, options) => toastFn({ type: "error", text, ...options });
    toastFn.info = (text, options) => toastFn({ type: "info", text, ...options });
    toastFn.warning = (text, options) => toastFn({ type: "warning", text, ...options });

    return toastFn;
  }, [addToast]);

  return toast;
};

export { useToast };
export default useToast;
